export type WebSocketStatus = 'idle' | 'open' | 'closed' | 'error';

export enum WebSocketStatuses {
  IDLE = 'idle',      // Initial state - not yet connected
  CLOSED = 'closed',  // Was connected, now closed
  OPEN = 'open',
  ERROR = 'error',
}
